import { useState } from "react";
import { Field, Honeypot, SubmitButton, SuccessBlock, useSubmit, inputCls, selectCls, validPhone, validEmail } from "./fields";
import { toast } from "sonner";

const INIT = {
  company_name: "", contact_person: "", designation: "", business_email: "", phone: "",
  location: "", industry: "", job_role: "", num_candidates: "", qualification_required: "",
  experience_required: "", salary_range: "", shift: "", joining_date: "", transport_required: "",
  food_canteen: "", accommodation: "", job_description: "", additional_requirements: "", website: "",
};

const INDUSTRIES = ["Automotive", "Manufacturing", "Engineering", "Electronics", "Defence Manufacturing", "Precision Components", "Solar & Renewable Energy", "Industrial Production", "Technology & Electronics Manufacturing", "Other"];
const SHIFTS = ["Day Shift", "Night Shift", "Rotational", "Flexible"];
const YESNO = ["Yes", "No", "Can be discussed"];

export default function EmployerForm() {
  const [f, setF] = useState(INIT);
  const { submit, loading, success, setSuccess } = useSubmit("/employer-requirements", "Thank you. Your manpower requirement has been received. Our team will contact you shortly.");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validPhone(f.phone)) return toast.error("Please enter a valid phone number.");
    if (!validEmail(f.business_email)) return toast.error("Please enter a valid business email.");
    const ok = await submit(f);
    if (ok) setF(INIT);
  };

  if (success)
    return <SuccessBlock testId="employer-form-success" message="Thank you. Your manpower requirement has been received. Our team will contact you shortly." contactEmail="info@maqlinesolutions.com" onReset={() => setSuccess(false)} />;

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="employer-form">
      <Honeypot value={f.website} onChange={set("website")} />
      <Field label="Company Name" required><input data-testid="ef-company" className={inputCls + " w-full"} value={f.company_name} onChange={set("company_name")} required /></Field>
      <Field label="Contact Person" required><input data-testid="ef-contact" className={inputCls + " w-full"} value={f.contact_person} onChange={set("contact_person")} required /></Field>
      <Field label="Designation"><input className={inputCls + " w-full"} value={f.designation} onChange={set("designation")} /></Field>
      <Field label="Business Email" required><input data-testid="ef-email" type="email" className={inputCls + " w-full"} value={f.business_email} onChange={set("business_email")} required /></Field>
      <Field label="Phone" required><input data-testid="ef-phone" className={inputCls + " w-full"} value={f.phone} onChange={set("phone")} required placeholder="+91" /></Field>
      <Field label="Location" required><input data-testid="ef-location" className={inputCls + " w-full"} value={f.location} onChange={set("location")} required placeholder="City / Area" /></Field>
      <Field label="Industry">
        <select className={selectCls} value={f.industry} onChange={set("industry")}>
          <option value="">Select industry</option>
          {INDUSTRIES.map((i) => <option key={i}>{i}</option>)}
        </select>
      </Field>
      <Field label="Job Role" required><input data-testid="ef-role" className={inputCls + " w-full"} value={f.job_role} onChange={set("job_role")} required placeholder="e.g. CNC Operator" /></Field>
      <Field label="Number of Candidates" required><input data-testid="ef-count" className={inputCls + " w-full"} value={f.num_candidates} onChange={set("num_candidates")} required placeholder="e.g. 25" /></Field>
      <Field label="Qualification Required"><input className={inputCls + " w-full"} value={f.qualification_required} onChange={set("qualification_required")} placeholder="e.g. ITI / Diploma" /></Field>
      <Field label="Experience Required"><input className={inputCls + " w-full"} value={f.experience_required} onChange={set("experience_required")} placeholder="e.g. Fresher / 1–3 years" /></Field>
      <Field label="Salary Range"><input className={inputCls + " w-full"} value={f.salary_range} onChange={set("salary_range")} placeholder="e.g. ₹18,000 – ₹24,000" /></Field>
      <Field label="Shift">
        <select className={selectCls} value={f.shift} onChange={set("shift")}>
          <option value="">Select shift</option>
          {SHIFTS.map((s) => <option key={s}>{s}</option>)}
        </select>
      </Field>
      <Field label="Joining Date"><input type="date" className={inputCls + " w-full"} value={f.joining_date} onChange={set("joining_date")} /></Field>
      <Field label="Transport Required">
        <select className={selectCls} value={f.transport_required} onChange={set("transport_required")}>
          <option value="">Select</option>
          {YESNO.map((s) => <option key={s}>{s}</option>)}
        </select>
      </Field>
      <Field label="Food / Canteen">
        <select className={selectCls} value={f.food_canteen} onChange={set("food_canteen")}>
          <option value="">Select</option>
          {YESNO.map((s) => <option key={s}>{s}</option>)}
        </select>
      </Field>
      <Field label="Accommodation">
        <select className={selectCls} value={f.accommodation} onChange={set("accommodation")}>
          <option value="">Select</option>
          {YESNO.map((s) => <option key={s}>{s}</option>)}
        </select>
      </Field>
      <Field label="Job Description" className="sm:col-span-2">
        <textarea className={inputCls + " w-full h-24 py-2.5"} value={f.job_description} onChange={set("job_description")} placeholder="Describe the role, responsibilities and work environment" />
      </Field>
      <Field label="Additional Requirements" className="sm:col-span-2">
        <textarea className={inputCls + " w-full h-24 py-2.5"} value={f.additional_requirements} onChange={set("additional_requirements")} placeholder="Anything else we should know" />
      </Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="employer-form-submit">Submit Manpower Requirement</SubmitButton>
      </div>
    </form>
  );
}
